import React from "react";
import { useTranslation } from "react-i18next";

const ButtonGroup = ({ buttons, activeButton, onButtonClick }) => {
  const { t } = useTranslation();
  return (
    <div className="colorful-button-group">
      <button
        key={"all"}
        className={`colorful-btn ${activeButton === "all" ? "active" : ""}`}
        onClick={() => onButtonClick("all")}
      >
        {t("all")}
      </button>
      {buttons.map((button) => (
        <button
          key={button.value}
          className={`colorful-btn ${
            activeButton === button.value ? "active" : ""
          }`}
          onClick={() => onButtonClick(button.value)}
        >
          {button.text}
        </button>
      ))}
    </div>
  );
};

export default ButtonGroup;
